import { render, staticRenderFns } from "./BuildingSimpleCompact.vue?vue&type=template&id=c02f9548&"
import script from "./BuildingSimpleCompact.vue?vue&type=script&lang=js&"
export * from "./BuildingSimpleCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports